import Vue from 'vue'
import wx from 'weixin-js-sdk'
import App from './App.vue'
import router from './router'
import store from './store'
import { Popup, Slider, Uploader, Toast } from 'vant'

import 'normalize.css'

Vue.use(Popup)
Vue.use(Slider)
Vue.use(Uploader)
Vue.use(Toast)

Vue.config.productionTip = false
Vue.prototype.$wx = wx
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
